import { Injectable } from '@angular/core';
import { AuthenticationMethodsPolicy } from '@microsoft/microsoft-graph-types-beta';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, distinct, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { retry } from 'projects/angular-clarity/src/app/pipes/retry.pipe';
import { TenantAjaxService } from 'projects/angular-clarity/src/app/services/ajax/tenant-ajax.service';

@Injectable()
export class AuthenticationMethodsPoliciesEffects {
    loadAuthenticationMethodsPolicies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.loadAuthenticationMethodsPolicies),
            distinct((action) => action._tenant),
            mergeMap(({ _tenant }) =>
                this.ajax
                    .get<AuthenticationMethodsPolicy>(
                        _tenant,
                        '/api/microsoft/graph/policies/authenticationMethodsPolicy',
                    )
                    .pipe(
                        retry(5000, 4, 'authentication methods policies timeout'),
                        map((policy: AuthenticationMethodsPolicy) =>
                            actions.loadAuthenticationMethodsPoliciesSuccess({
                                _tenant,
                                policy,
                            }),
                        ),
                        catchError((error) =>
                            of(
                                actions.loadAuthenticationMethodsPoliciesFailure({
                                    _tenant,
                                    error,
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );

    updateAuthenticationMethodConfig$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateAuthenticationMethodPolicyConfig),
            mergeMap(({ _tenant, policy }) =>
                this.ajax
                    .patch<any>(
                        _tenant,
                        `/api/microsoft/graph/policies/authenticationMethodsPolicy/authenticationMethodConfigurations/${policy.id}`,
                        policy,
                    )
                    .pipe(
                        map((config) => actions.updateAuthenticationMethodPolicyConfigSuccess({ _tenant, policy })),
                        catchError((error) =>
                            of(actions.updateAuthenticationMethodPolicyConfigFailure({ _tenant, error })),
                        ),
                    ),
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private ajax: TenantAjaxService,
    ) {}
}
